import { exams } from '../../../api/exams';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import React from "react";
import { useMutation, useQuery } from "react-query";
import { v4 } from "uuid";
import Loader from '../../../components/loader/Loader';
import Result from './components/Result';
import { useDispatch } from 'react-redux';
import { clearFlaggedQuestion } from '../../../features/candidate-exam/candidate-exam-slice';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

const Results = () => {

  const { id } = useParams()
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const userExamId = searchParams.get('userExamId');
  const user = JSON.parse(sessionStorage.getItem('user'))
  const userId = user?.user_id || user?.id || user?.user?.user_id || sessionStorage.getItem('user_id');
  const userName = user?.name || user?.user?.name || 'Candidate';
  const isSshAssessment = sessionStorage.getItem('ssh_source') === 'ssh';

  const returnToSsh = () => {
    if (window.parent !== window) {
      window.parent.postMessage(
        {
          type: 'ssh-assessment-completed',
          assessmentId: id,
          userExamId,
        },
        '*'
      );
      return;
    }

    window.close();
    window.setTimeout(() => window.history.back(), 100);
  };

  const { data: results, isLoading } = useQuery(
    ["exam results"],
    async () => {
      const data = await exams.getExamResults({
        userId,
        assessmentId: id,
        userExamId
      });
      return data;
    },
    {
      select: (response) => response,
    },
  );

  const results_ = results?.results || []
  const brandedClient = JSON.parse(sessionStorage.getItem("client") || '{}');


  if (isLoading) {
    return <Loader />;
  }

  return (
    <React.Fragment>
      <header className='bg-white sticky text-xl top-0 flex font-semibold justify-between items-center py-5 px-4 rounded-md mb-4'>
        Exam Result ({sessionStorage.getItem('activeExam')})
        <h1 className="text-slate-600 font-semibold text-xl">Candidate Name: {userName}</h1>
        {isSshAssessment && (
          <button
            type="button"
            onClick={returnToSsh}
            style={{ backgroundColor: brandedClient?.primary_colour || undefined }}
            className="rounded-lg bg-primary px-5 py-2.5 text-sm font-medium text-white hover:bg-primary-focus"
          >
            Return to Service School House
          </button>
        )}
        { /*
          parseInt(sessionStorage.getItem('attempt_count')) <= 3 ?
              <button style={{ backgroundColor: brandedClient?.primary_colour || undefined}} className="text-white bg-primary hover:bg-primary-focus focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              onClick={ () => retakeExam(id) }
                >
                   {retakeLoading ? t('loading') : t('retake-exam')} 
             </button>
          : null */
        }
      </header>

      {
        <section className='bg-yellow-100 font-semibold text-lg border border-yellow-500 p-5 mt-5 rounded-lg'>
          {t('provisional-score-notice')}
        </section>
      }
      {/* <header className='bg-white flex justify-between items-center py-5 px-4 rounded-md mb-4'>
        <h1 className='text-lg'>
          Overall Results Status:
          <span
            className={`capitalize ml-2 text-${
              results?.overall_result_status && statusColor[results?.overall_result_status]}`
              }
            >
              {results?.overall_result_status}
            </span>
        </h1>
      </header> */}
      {/*USER DETAILS*/}
      {/* <UserDetails /> */}
      {/*RESULTS*/}
      {
        // disable result view by section
        results_?.length ?
          [...results_]?.sort((a, b) => {
            const dateA = new Date(a?.result?.completed_at).getTime();
            const dateB = new Date(b?.result?.completed_at).getTime();
            return dateB - dateA;
          })?.map((results, index) => {
            return (
              <section className='mb-5 rounded-md' key={v4()}>
                <Result
                  key={v4()}
                  results={results}
                  isLoading={isLoading}
                  index={index}
                />
              </section>
            )
          })
          : null
      }
    </React.Fragment>
  );
};

export default Results;
